function polyfillGlobalThis() {
    if (typeof globalThis !== 'undefined') {
        return globalThis;
    }
    Object.defineProperty(Object.prototype, 'globalThis', {
        get: function() {
            const g = (this.globalThis = this);
            delete Object.prototype.globalThis;
            return g;
        },
        configurable: true
    });
    return globalThis;
}

window.globalThis = polyfillGlobalThis();
